export default class PlayersListNotFoundError extends Error {}
